module.exports = __webpack_public_path__ + "img/foreground.2b2b4a59.png";